// Derive "when did this person last do duty?" from the hut-duty slots embedded
// in each roster row by GET /api/admin/hut-duties. Kept pure and free of the
// api.ts types (structural params) so it unit-tests without a fixture.

type SlotRange = { check_in: string; check_out: string };

/**
 * Check-out date of the most recent duty that has already finished, or null if
 * the person has never served. Slots are half-open [check_in, check_out), so a
 * duty counts as done once check_out is reached. YYYY-MM-DD strings compare
 * lexicographically, so no Date parsing is needed.
 */
export function lastDutyDate(slots: SlotRange[], today: string): string | null {
  let latest: string | null = null;
  for (const s of slots) {
    if (s.check_out > today) continue;
    if (latest === null || s.check_out > latest) latest = s.check_out;
  }
  return latest;
}
